import { useState } from 'react';

const InteractiveColorPicker = () => {
  const [r, setR] = useState(255);
  const [g, setG] = useState(0);
  const [b, setB] = useState(153);
  const [a, setA] = useState(1);

  const hex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  const rgb = `rgb(${r}, ${g}, ${b})`;
  const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;

  const SliderRow = ({ label, value, onChange, max = 255, color }) => (
    <div className="flex items-center gap-3 mb-3">
      <span className="text-xs font-mono text-[#A1A1AA] w-8">{label}</span>
      <input
        type="range"
        min="0"
        max={max}
        step={max === 1 ? 0.01 : 1}
        value={value}
        onChange={e => onChange(parseFloat(e.target.value))}
        className="flex-1 h-2 rounded-full appearance-none cursor-pointer"
        style={{ accentColor: color || '#FF0099' }}
        data-testid={`color-slider-${label.toLowerCase()}`}
      />
      <span className="text-xs font-mono text-white w-10 text-right">{max === 1 ? value.toFixed(2) : value}</span>
    </div>
  );

  return (
    <div className="my-6 bg-[#121225]/80 border border-white/10 rounded-2xl p-6" data-testid="color-picker">
      <h3 className="text-lg font-bold font-outfit text-white mb-4">Interactive Color Picker</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <SliderRow label="R" value={r} onChange={setR} color="#ff4444" />
          <SliderRow label="G" value={g} onChange={setG} color="#44ff44" />
          <SliderRow label="B" value={b} onChange={setB} color="#4444ff" />
          <SliderRow label="A" value={a} onChange={setA} max={1} color="#ffffff" />
        </div>

        <div>
          <div
            className="w-full h-32 rounded-xl border border-white/20 mb-4"
            style={{ backgroundColor: rgba }}
            data-testid="color-preview"
          />
          <div className="space-y-2 font-mono text-sm">
            <div className="flex justify-between bg-white/5 rounded-lg px-3 py-2">
              <span className="text-[#A1A1AA]">Hex:</span>
              <span className="text-[#88ff88]">{hex}</span>
            </div>
            <div className="flex justify-between bg-white/5 rounded-lg px-3 py-2">
              <span className="text-[#A1A1AA]">RGB:</span>
              <span className="text-[#79c0ff]">{rgb}</span>
            </div>
            <div className="flex justify-between bg-white/5 rounded-lg px-3 py-2">
              <span className="text-[#A1A1AA]">RGBA:</span>
              <span className="text-[#ffa657]">{rgba}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveColorPicker;
